import Environment from "./environment";

/**
 * セレクトボックス関連 Class
 */
export default class SelectBox {
	constructor() {
		this.changeEvent();
	};

	/**
	 * 変更イベント
	 */
	changeEvent() {
		const self = this;
		$('#js-space-category').change(function(){
			let val = $(this).val();
			self.categoryRouter('space_category', val);
		});
		$('#js-type-category').change(function () {
			let val = $(this).val();
			self.categoryRouter('type_category', val);
		});
	};

	/**
	 * カテゴリーページ推移
	 * @param {string} category
	 * @param {string} val
	 */
	categoryRouter(category, val) {
		let homeUrl = Environment.getHomeUrl();
		let categoryUrl = '';
		if (val == 'all') {
			categoryUrl = homeUrl + 'works/';
		} else {
			categoryUrl = homeUrl + 'works/' + category + '/' + val + '/';
		}
		window.location.href = categoryUrl;
	};
}
